import { ComponentProps } from 'react';
import { Badge } from '../../../../../design-system/badge/badge';
import { exhaustiveCheck } from '../../../../../utils/exhaustive-check';
import { PaidInvoiceMatchingStatus } from './get-paid-invoice-matching-status';

type BadgeVariant = Extract<ComponentProps<typeof Badge>['variant'], 'neutral' | 'negative' | 'positive' | 'attention'>;

export const getPaidInvoiceMatchingStatusBadgeVariant = (status: PaidInvoiceMatchingStatus): BadgeVariant => {
  switch (status) {
    case 'Paid via Seapoint':
      return 'positive';
    case 'Unknown':
    case 'Automatched':
    case 'Manually matched':
      return 'neutral';
    case 'No matched transaction':
      // Note: Currently displayed as plain text (no badge) in the table,
      // but 'attention' variant defined here for type completeness and
      // to indicate this status warrants user attention (invoice paid
      // without corresponding transaction record)
      return 'attention';
    case 'Transaction removed':
      // Attention variant to indicate the transaction was removed (pending transaction that settled)
      // This requires user attention to review if the match is still correct
      return 'attention';
    default:
      return exhaustiveCheck(status);
  }
};
